import { atom, selector } from 'recoil';
import { verificarToken } from './storage';

const tokenEffect =
  () =>
  ({ trigger, onSet, setSelf }) => {
    const key = 'tokenEcosurEstudiantesExternos';
    const token = localStorage.getItem(key);
    if (trigger === 'get' && token && verificarToken(token)) {
      setSelf(token);
    }
    onSet((newValue: any) => {
      if (verificarToken(newValue)) {
        localStorage.setItem(key, newValue);
        setSelf(newValue);
        window.location.href = '/';
      } else {
        localStorage.removeItem(key);
        setSelf(null);
        window.location.href = '/';
      }
    });
  };

export const tokenState = atom({
  key: 'tokenState',
  default: null,
  effects: [tokenEffect()],
});

export const tokenInfo = selector({
  key: 'tokenInfo',
  get: ({ get }) => ({
    token: get(tokenState),
  }),
});
